import React from 'react'

import { Col, Row } from '_zari/core'

import * as Formatos from './formatos'

const CentrosCostoReportes = () => {
  return (
    <Row>
      <Col md={12}>
        <Row className='zari-slim-form'>
          <Col md={6}>
            <Formatos.ReporteModuloCosto />
          </Col>
          <Col md={6}>
            <Formatos.ReporteCruceClase6 />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Formatos.RelacionAsientosCentrosFormato />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default React.memo(CentrosCostoReportes)
